/**
 * Implements a list of reviewers used by chart edit screens where reviewer
 * selection is possible.
 */

import Brace from "backbone.brace";
import AccountModel from "../../../models/account-data";

const Model = AccountModel.extend({
  namedAttributes: {
    checked: Boolean,
  },
  defaults: {
    checked: false,
  },
});

const Collection = Brace.Collection.extend({
  // sort collection by name per FB: 72386 & 72402
  comparator: "firstName",
  model: Model,
});

export { Collection as default };
